import { LoadingSceneBackdrop } from "~mangomap-ui/components/loading-scene/loading-scene-backdrop";
import { DEFAULT_MANGO_LOGO_URL } from "~utils/functions/whitelabel-branding";
import { useRouter } from "next/router";
import { FC, ReactNode, useEffect } from "react";

import { usePartnerAuth } from "../context";
import { withRedirQuery } from "../redir";

interface PartnerAuthRequiredProps {
	children: ReactNode;
}

export const PartnerAuthRequired: FC<PartnerAuthRequiredProps> = ({
	children,
}) => {
	const router = useRouter();
	const { isLoading, isAuthenticated } = usePartnerAuth();

	useEffect(() => {
		if (!isLoading && !isAuthenticated) {
			void router.replace(
				withRedirQuery({
					signInPath: "/sign-in",
					redirPath: router.asPath,
				}),
			);
		}
	}, [isLoading, isAuthenticated, router]);

	if (isLoading || !isAuthenticated) {
		return <LoadingSceneBackdrop logoUrl={DEFAULT_MANGO_LOGO_URL} />;
	}

	return children;
};
